import RecentlyViewedTable from "@/components/ListTable/RecentlyViewedTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { TAB_KEYS } from "@/constants/TabKeys";
import { ListProvider } from "@/modules/list";

const RecentlyViewed = () => {
  return (
    <ListProvider
      endpoint="user.recents"
      storageKey={STORAGE_KEYS.MY_SPACE_RECENTS}
      contextTabValue={TAB_KEYS.MY_SPACE_RECENTS}
    >
      <RecentlyViewedTable />
    </ListProvider>
  );
};

RecentlyViewed.propTypes = {};

export default RecentlyViewed;
